import { defineComponent as _defineComponent } from 'vue'
import { IDataChart, IDataChartMore, IHeadersTable, IStep, ITab, IToggleButon } from '@/types';
import { ref, onMounted, computed, watch } from 'vue';
import { OrganismsChart, OrganismsChartSaltos } from '@/components/organisms';
import {
  AtomProgressSaltos,
  AtomToogleButton,
  ArrowLeftMobileIcon,
  AtomSubTitle,
  AtomButton,
} from '@/components/atoms';

import { MoleculeTable, MoleculeTabs, MoleculeTabWindow, MoleculeTabItem } from '@/components/molecules';
import { getters } from '@/store/modules/layout';
import { useRoute, useRouter } from 'vue-router';
import { Authentication, FiltersUnit } from '@/store/index';
import {
  dadosPingMinutoAnalitico,
  linksPorStatusConectividade,
  linksServicosPorStatusConectividade,
  servicosPorStatusConectividade,
  consumoCpu,
  consumoInternet,
  graficoPontosPorHora,
} from '@/core/services/GraficoService';
import { getInvestigate, getPredict, InvestigateAll } from '@/core/services/PredictService';
import { Preloader } from '@/store';
import {
  dadosPingDia,
  dadosPingMinuto,
  dadosPingHora,
  dadosCaminhoConectividade,
} from '@/core/services/GraficoService';
import { state } from '@/store/modules/layout';
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'InvestigationPage',
  setup(__props, { expose: __expose }) {
  __expose();

const perPage = ref<number>(10);
const page = ref<number>(1);
const tabs = ref<ITab[]>([
  {
    label: 'Geral',
    value: 'general',
    tooltips: undefined,
  },
  {
    label: 'Analítico',
    value: 'analitics',
  },
]);
const tab = ref<string>(tabs.value[0].value);
const selectedRow = ref();
const route = useRoute();
const router = useRouter();
// interface Props {
//   investigarItem?: any;
// }
// const props = withDefaults(defineProps<Props>(), { investigarItem: {} });

const isPredict = computed(() => {
  return route.fullPath.includes('predicao');
});
const diagnostico = ref<any>({});

const analitsData = ref<any[]>([]);
const labelComplementar = computed(() => {
  return investigandoDadoSelecionado.value.client_unity_name
    ? ` do(a) ${investigandoDadoSelecionado.value.service_name} da unidade ${investigandoDadoSelecionado.value.client_unity_name}`
    : investigandoDadoSelecionado.value.service_name
      ? ` do(a) ${investigandoDadoSelecionado.value.service_name}`
      : '';
});

const labelComplementarAnalitico = computed(() => {
  return investigandoDadoSelecionadoAnalitico.value.client_unity_name
    ? ` do(a) ${investigandoDadoSelecionadoAnalitico.value.service_name} da unidade ${investigandoDadoSelecionadoAnalitico.value.client_unity_name}`
    : investigandoDadoSelecionadoAnalitico.value.service_name
      ? ` do(a) ${investigandoDadoSelecionadoAnalitico.value.service_name}`
      : '';
});
const itemsDiagnostics = ref<any[]>([
  {
    icon: 'ShieldDoneIcon',
    isPositive: true,
    item: 'Saudáveis',
    value: 0,
    nFloat: 0,
    color: '#15D095',
    id: '0',
    data: {},
    text: 'Quando a Qualidade e a Disponibilidade estão acima de 50%',
    loading: true,
  },
  {
    icon: 'DangerTriangleIcon',
    isPositive: true,
    item: 'Instáveis',
    value: 0,
    nFloat: 0,
    color: '#FFE70D',
    id: '1',
    data: {},
    text: 'Quando a Qualidade está acima de 50% a Disponibilidade está abaixo de 50%',
    loading: true,
  },
  {
    icon: 'ArrowDownCircleIcon',
    isPositive: false,
    item: 'Degradados',
    value: 0,
    nFloat: 0,
    color: '#FF9E0D',
    id: '2',
    data: {},
    text: 'Quando a Qualidade está abaixo de 50% a Disponibilidade está acima de 50%',
    loading: true,
  },
  {
    icon: 'ShieldFailIcon',
    isPositive: false,
    item: 'Problemáticos',
    value: 0,
    nFloat: 0,
    color: '#FF0D21',
    id: '3',
    data: {},
    text: 'Quando a Qualidade e a Disponibilidade estão abaixo de 50%',
    loading: true,
  },
  {
    icon: 'ShieldDoneIcon',
    isPositive: true,
    item: 'Pontos por hora',
    value: 0,
    // nFloat: 0,
    id: '4',
    data: {},
    loading: true,
  },
]);

const totalizadores = ref<any[]>([]);
const investigarItem = ref<any>({});

const analistsDataComputed = computed(() => {
  const data = analitsData.value.slice(
    (page.value - 1) * perPage.value,
    (page.value - 1) * perPage.value + perPage.value,
  );
  return data;
});

const steps = ref<IStep[]>([]);
const stepsAnalitco = ref<IStep[]>([]);
//   [
//   { label: 'Salto 1', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
//   { label: 'Salto 2', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
//   { label: 'Salto 3', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
//   { label: 'Salto 4', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
//   { label: 'Salto 5', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
//   { label: 'Salto 6', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
//   { label: 'Salto 7', completed: true, latencia: '3 ms', jitter: '0 ms', perda: '66' },
// ]
const activeColor = computed(() => {
  const color = !isPredict.value ? '#FF5C00' : '#292E36';
  return color;
});
const currentStep = ref('');
const currentStepAnalitico = ref('');
const dataChar = ref<IDataChart[]>([
  { title: '14:40h', value: 110 },
  { title: '14:43h', value: 95 },
]);
const dataCharAnalitico = ref<IDataChart[]>([
  { title: '14:40h', value: 110 },
  { title: '14:43h', value: 95 },
]);
const optionsListLatencia = computed((): IToggleButon[] => {
  return !isPredict.value
    ? [
      { value: '3minutos', text: '3 Minutos' },
      { value: 'minutos', text: '30 Minutos', selected: true },
      { value: 'horas', text: '1 Hora' },
      { value: 'dias', text: '8 horas' },
    ]
    : [
      // { value: '3minutos', text: '+ 3 Minutos' },
      { value: 'minutos', text: '+ 30 Minutos', selected: true },
      { value: '1horas', text: '+ 1 Horas' },
      { value: '3horas', text: '+ 3 horas' },
    ];
});
const optionsListPerda = computed((): IToggleButon[] => {
  return !isPredict.value
    ? [
      { value: '3minutos', text: '3 Minutos' },
      { value: 'minutos', text: '30 Minutos', selected: true },
      { value: 'horas', text: '1 Hora' },
      { value: 'dias', text: '8 Horas' },
    ]
    : [
      // { value: '3minutos', text: '+ 3 Minutos' },
      { value: 'minutos', text: '+ 30 Minutos', selected: true },
      { value: '1horas', text: '+ 1 Horas' },
      { value: '3horas', text: '+ 3 horas' },
    ];
});
const optionsGeral = computed((): IToggleButon[] => {
  return !isPredict.value
    ? [
      { value: 'Horas', text: '3 Horas' },
      { value: 'dias', text: '8 Horas', selected: true },
    ]
    : [
      // { value: '3minutos', text: '+ 3 Minutos' },
      { value: 'horas', text: '+ 5 Horas' },
      { value: 'dias', text: '+ 8 Horas', selected: true },
    ];
});

const options = ref<IToggleButon[]>([
  { value: '3minutos', text: '3 Minutos' },
  { value: 'minutos', text: '30 Minutos', selected: true },
  { value: 'horas', text: '1 Hora' },
  { value: 'dias', text: '8 Horas' },
]);

const optionsListJitter = computed((): IToggleButon[] => {
  return !isPredict.value
    ? [
      { value: '3minutos', text: '3 Minutos' },
      { value: 'minutos', text: '30 Minutos', selected: true },
      { value: 'horas', text: '1 Hora' },
      { value: 'dias', text: '8 Horas' },
    ]
    : [
      // { value: '3minutos', text: '+ 3 Minutos' },
      { value: 'minutos', text: '+ 30 Minutos', selected: true },
      { value: '1horas', text: '+ 1 Horas' },
      { value: '3horas', text: '+ 3 horas' },
    ];
});
const headersDetails = computed((): IHeadersTable[] => {
  if (isPredict.value) {
    return [
      { label: 'Unidade', field: 'client_unity_name' },
      { label: 'Link/Serviço', field: 'service_name' },
      { label: 'Disponibilidade', field: 'availability' },
      { label: 'Qualidade', field: 'quality' },
    ];
  } else {
    return [
      {
        label: 'Unidade',
        field: 'client_unity_name',
      },
      { label: 'Link/Serviço', field: 'service_name' },
      { label: 'Disponibilidade', field: 'availability' },
      { label: 'Qualidade', field: 'quality' },
    ];
  }
});

const headersAnalitisc = ref<IHeadersTable[]>([
  {
    label: 'Unidade',
    field: 'client_unity_name',
  },
  { label: 'Link/Serviço', field: 'service_name' },
  { label: 'Usuário', field: 'usuario' },
  { label: 'Máquina', field: 'hostName' },
  {
    label: 'Data e Hora',
    field: 'insert_time',
    formatFn: (value: string | number | Date) => {
      try {

        return format(new Date(value), 'dd/MM/yyyy hh:mm:ss');
      } catch (err) {
        return value;
      }
    },
  },
  {
    label: 'Coletor',
    field: 'coletor',
  },
  { label: 'Disponibilidade', field: 'availability' },
  { label: 'Qualidade', field: 'quality' },
]);
const dadosPredict = ref<any>();
const dadosPredictAlvo = computed(() => {
  return investigandoDadoSelecionado.value != null
    ? dadosPredict.value.filter((f: { name: any }) => f.name == investigandoDadoSelecionado.value.service_name)
    : [];
});
// const dadosPredictAnalitico = ref<any>();
// const dadosPredictAlvoAnalitico = computed(() => {
//   return investigandoDadoSelecionadoAnalitico.value != null
//     ? dadosPredictAnalitico.value.filter((f: { name: any }) => f.name == investigandoDadoSelecionadoAnalitico.value.service_name)
//     : [];
// });
// const dadosPredictAlvoAnalitico = computed(() => {
//   return investigandoDadoSelecionadoAnalitico.value != null
//     ? dadosPredict.value.filter((f) => f.name == investigandoDadoSelecionadoAnalitico.value.service_name)
//     : [];
// });
const jitterChatLine = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Jitter',
    data: [],
  },
]);
const latenciaChatLine = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Latência',
    data: [],
  },
]);
const perdaPacoteChatLine = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Perda de Pacote',
    data: [],
  },
]);

const jitterChatLineAnalitico = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Jitter',
    data: [],
  },
]);
const latenciaChatLineAnalitico = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Latência',
    data: [],
  },
]);
const perdaPacoteChatLineAnalitico = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Perda de Pacote',
    data: [],
  },
]);
const cpuAnalitico = ref<IDataChartMore[]>([
  {
    color: '#FF5C00',
    name: 'CPU',
    data: [],
  },
]);
const consumoInternetArray = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Consumo Internet',
    data: [],
  },
]);

const pontosPorHoraArray = ref<IDataChartMore[]>([
  {
    color: activeColor.value,
    name: 'Score de Conectividade de Pontos por hora',
    data: [],
  },
]);
// const caminhoConectividadeChatLine = ref<IDataChartMore[]>([
//   {
//     color: activeColor.value,
//     name: 'Caminho de Conectividade',
//     data: [],
//   },
// ]);
const investigandoDadoSelecionado = ref<any>({});
const investigandoDadoSelecionadoAnalitico = ref<any>({});
function handleReturnDash() {
  router.go(-1);
}
function handleRowClick(payload: any) {
  Preloader.actions.timeless();
  investigandoDadoSelecionado.value = payload?.row ?? payload;
  if (!isPredict.value) {
    if (investigandoDadoSelecionado.value.connService_id)
      dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 30).then((f) => {
        GetLoadJitter(f);
        GetLoadLatencia(f);
        GetLoadPerdaPacote(f);
      });
    getSaltos();
  } else {
    GetLoadJitter(dadosPredictAlvo.value);
    GetLoadLatencia(dadosPredictAlvo.value);
    GetLoadPerdaPacote(dadosPredictAlvo.value);
  }
}

function handleRowClickAnalitico(payload: any) {
  window.scrollTo(0, 500);
  Preloader.actions.timeless();
  selectedRow.value = payload?.row?.id;
  investigandoDadoSelecionadoAnalitico.value = payload?.row ?? payload;
  if (!isPredict.value) {
    if (investigandoDadoSelecionadoAnalitico.value.connService_id)

      dadosPingMinutoAnalitico(
        investigandoDadoSelecionadoAnalitico.value.connService_id,
        30,
        investigandoDadoSelecionadoAnalitico.value.hostName,
        investigandoDadoSelecionadoAnalitico.value.usuario,
      ).then((f) => {
        GetLoadJitterAnalitico(f);
        GetLoadLatenciaAnalitico(f);
        GetLoadPerdaPacoteAnalitico(f);
      });

    cpuGet();
    internetGet();
    getSaltosAnalitico();
    graficoPontosHora();

  } else {
    GetLoadJitterAnalitico(analitsData.value);
    GetLoadLatenciaAnalitico(analitsData.value);
    GetLoadPerdaPacoteAnalitico(analitsData.value);
  }

}

const pontosPorHora = ref<number>(0);
function cpuGet() {
  /*
    { value: '3minutos', text: '3 Minutos' },
  { value: 'minutos', text: '30 Minutos', selected: true },
  { value: 'horas', text: '1 Hora' },
  { value: 'dias', text: '8 Horas' },
  */
  consumoCpu(
    investigandoDadoSelecionadoAnalitico.value.connService_id,
    investigandoDadoSelecionadoAnalitico.value.hostName,
    investigandoDadoSelecionadoAnalitico.value.usuario,
    toogleCpu.value == '3minutos'
      ? '3'
      : toogleCpu.value == 'minutos'
        ? '30'
        : toogleCpu.value == 'horas'
          ? '60'
          : '480',
  ).then((f) => {
    cpuAnalitico.value[0].data = f.map((x: { hora: any; minuto: any; cpuconsumo: any }) => {
      return { title: `${x.hora}:${x.minuto}`, value: x.cpuconsumo } as IDataChart;
    });
  });
}
function internetGet() {
  consumoInternet(
    investigandoDadoSelecionadoAnalitico.value.coletorid,
    investigandoDadoSelecionadoAnalitico.value.hostName,
    investigandoDadoSelecionadoAnalitico.value.usuario,
    toogleConsumoInternet.value == '3minutos'
      ? '3'
      : toogleConsumoInternet.value == 'minutos'
        ? '30'
        : toogleConsumoInternet.value == 'horas'
          ? '60'
          : '480',
  ).then((f) => {
    const titler = f
      .map((x: { tipo: any }) => x.tipo)
      .filter((value: any, index: any, array: string | any[]) => {
        return array.indexOf(value) === index;
      });

    const data = titler.map((x: any) => {
      const dato = {
        color: '',
        name: x,
        data: f
          .filter((xx: { tipo: any }) => xx.tipo == x)
          .map((x: any) => {
            return { title: `${x.hora}:${x.minuto}`, value: x.mbps } as IDataChart;
          }),
      };

      return dato;
    });

    consumoInternetArray.value = data;
  });
}

function graficoPontosHora() {
  graficoPontosPorHora(
    investigandoDadoSelecionadoAnalitico.value.connService_id,
    investigandoDadoSelecionadoAnalitico.value.hostName,
    investigandoDadoSelecionadoAnalitico.value.usuario,

    '480',
  ).then((resp) => {
    pontosPorHora.value = resp.pontosPorHora;
    pontosPorHoraArray.value = resp.horasSCLista.map((x: { hora: any; pontosPorHora: any }) => {
      return { title: `${x.hora}`, value: x.pontosPorHora } as IDataChart;
    });
  });
}

const tooglePerdaPacote = ref<string>('minutos');
const toogleJitter = ref<string>('minutos');
const toogleLatencia = ref<string>('minutos');

const tooglePerdaPacoteAnalitico = ref<string>('minutos');
const toogleGeralAnalitico = ref<string>('dias');
const toogleJitterAnalitico = ref<string>('minutos');
const toogleLatenciaAnalitico = ref<string>('minutos');

const toogleCpu = ref<string>('minutos');
const toogleConsumoInternet = ref<string>('minutos');
const toogleScore = ref<string>('minutos');

watch(
  () => tooglePerdaPacoteAnalitico.value,
  () => {
    if (!isPredict.value) {
      if (investigandoDadoSelecionadoAnalitico.value.connService_id) {
        if (tooglePerdaPacoteAnalitico.value == 'minutos') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            30,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacoteAnalitico(f);
          });
        } else if (tooglePerdaPacoteAnalitico.value == '3minutos') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            3,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacoteAnalitico(f);
          });
        } else if (tooglePerdaPacoteAnalitico.value == 'horas') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            60,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacoteAnalitico(f);
          });
        } else if (tooglePerdaPacoteAnalitico.value == 'dias') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            480,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacoteAnalitico(f);
          });
        }
      }
    } else {
      if (rodouPrimary.value)
        getPredictInvestigate(
          tooglePerdaPacote.value == 'minutos' ? '30' : tooglePerdaPacote.value == '1horas' ? '60' : '180',
        ).then(() => {
          GetLoadPerdaPacoteAnalitico(dadosPredictAlvo.value);
        });
    }
  },
);
watch(
  () => toogleGeralAnalitico.value,
  () => {
    Preloader.actions.ActionSetPreloader(true);

    getInvestigateAll(toogleGeralAnalitico.value == 'horas' ? '300' : tooglePerdaPacote.value == 'dias' ? '480' : '300').then(() => {
      GetLoadJitterAnalitico(analitsData.value);
      GetLoadLatenciaAnalitico(analitsData.value);
      GetLoadPerdaPacoteAnalitico(analitsData.value);

      Preloader.actions.ActionSetPreloader(false);
    })




  }
);

watch(
  () => toogleJitterAnalitico.value,
  () => {
    // GetLoadJitter([]);
    if (!isPredict.value) {
      if (investigandoDadoSelecionadoAnalitico.value.connService_id) {
        if (toogleJitterAnalitico.value == 'minutos') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            30,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            GetLoadJitter(f);
            // GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleJitterAnalitico.value == '3minutos') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            3,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            GetLoadJitterAnalitico(f);
          });
        } else if (toogleJitterAnalitico.value == 'horas') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            60,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            GetLoadJitterAnalitico(f);
          });
        } else if (toogleJitterAnalitico.value == 'dias') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            480,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            GetLoadJitterAnalitico(f);
          });
        }
      }
    } else {
      if (rodouPrimary.value)
        getPredictInvestigate(
          toogleJitter.value == 'minutos' ? '30' : toogleJitter.value == '1horas' ? '60' : '180',
        ).then(() => {
          GetLoadJitterAnalitico(dadosPredictAlvo.value);
        });
    }
  },
);

watch(
  () => toogleLatenciaAnalitico.value,
  () => {
    if (!isPredict.value) {
      if (investigandoDadoSelecionadoAnalitico.value.connService_id) {
        if (toogleLatenciaAnalitico.value == 'minutos') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            30,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatenciaAnalitico(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleLatenciaAnalitico.value == '3minutos') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            3,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatenciaAnalitico(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleLatenciaAnalitico.value == 'horas') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            60,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatenciaAnalitico(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleLatenciaAnalitico.value == 'dias') {
          dadosPingMinutoAnalitico(
            investigandoDadoSelecionadoAnalitico.value.connService_id,
            480,
            investigandoDadoSelecionadoAnalitico.value.hostName,
            investigandoDadoSelecionadoAnalitico.value.usuario,
          ).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatenciaAnalitico(f);
            // GetLoadPerdaPacote(f);
          });
        }
      }
    } else {
      if (rodouPrimary.value)
        getPredictInvestigate(
          toogleLatencia.value == 'minutos' ? '30' : toogleLatencia.value == '1horas' ? '60' : '180',
        ).then(() => {
          GetLoadLatenciaAnalitico(dadosPredictAlvo.value);
        });
    }
  },
);

watch(
  () => tooglePerdaPacote.value,
  () => {
    if (!isPredict.value) {
      if (investigandoDadoSelecionado.value.connService_id) {
        if (tooglePerdaPacote.value == 'minutos') {
          dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 30).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacote(f);
          });
        } else if (tooglePerdaPacote.value == '3minutos') {
          dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 3).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacote(f);
          });
        } else if (tooglePerdaPacote.value == 'horas') {
          dadosPingHora(investigandoDadoSelecionado.value.connService_id).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacote(f);
          });
        } else if (tooglePerdaPacote.value == 'dias') {
          dadosPingDia(investigandoDadoSelecionado.value.connService_id).then((f) => {
            // GetLoadJitter(f);
            // GetLoadLatencia(f);
            GetLoadPerdaPacote(f);
          });
        }
      }
    } else {
      if (rodouPrimary.value)
        getPredictInvestigate(
          tooglePerdaPacote.value == 'minutos' ? '30' : tooglePerdaPacote.value == '1horas' ? '60' : '180',
        ).then(() => {
          GetLoadPerdaPacote(dadosPredictAlvo.value);
        });
    }
  },
);

watch(
  () => toogleJitter.value,
  () => {
    // GetLoadJitter([]);
    if (!isPredict.value) {
      if (investigandoDadoSelecionado.value.connService_id) {
        if (toogleJitter.value == 'minutos') {
          dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 30).then((f) => {
            GetLoadJitter(f);
            // GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleJitter.value == '3minutos') {
          dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 3).then((f) => {
            GetLoadJitter(f);
            // GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleJitter.value == 'horas') {
          dadosPingHora(investigandoDadoSelecionado.value.connService_id).then((f) => {
            GetLoadJitter(f);
            // GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleJitter.value == 'dias') {
          dadosPingDia(investigandoDadoSelecionado.value.connService_id).then((f) => {
            GetLoadJitter(f);
            // GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        }
      }
    } else {
      if (rodouPrimary.value)
        getPredictInvestigate(
          toogleJitter.value == 'minutos' ? '30' : toogleJitter.value == '1horas' ? '60' : '180',
        ).then(() => {
          GetLoadJitter(dadosPredictAlvo.value);
        });
    }
  },
);

watch(
  () => toogleCpu.value,
  () => {
    cpuGet();
  },
);

watch(
  () => toogleConsumoInternet.value,
  () => {
    internetGet();
  },
);

watch(
  () => toogleScore.value,
  () => {
    graficoPontosHora();
  },
);

watch(
  () => toogleLatencia.value,
  () => {
    if (!isPredict.value) {
      if (investigandoDadoSelecionado.value.connService_id) {
        if (toogleLatencia.value == 'minutos') {
          dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 30).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleLatencia.value == '3minutos') {
          dadosPingMinuto(investigandoDadoSelecionado.value.connService_id, 3).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleLatencia.value == 'horas') {
          dadosPingHora(investigandoDadoSelecionado.value.connService_id).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        } else if (toogleLatencia.value == 'dias') {
          dadosPingDia(investigandoDadoSelecionado.value.connService_id).then((f) => {
            // GetLoadJitter(f);
            GetLoadLatencia(f);
            // GetLoadPerdaPacote(f);
          });
        }
      }
    } else {
      if (rodouPrimary.value)
        getPredictInvestigate(
          toogleLatencia.value == 'minutos' ? '30' : toogleLatencia.value == '1horas' ? '60' : '180',
        ).then(() => {
          GetLoadLatencia(dadosPredictAlvo.value);
        });
    }
  },
);

const rodouPrimary = ref<boolean>(false);

function handleJiterChange(payload: string) {
  if (toogleJitter.value == payload) return;
  toogleJitter.value = payload;
}
function handlePerdaPacoteChange(payload: string) {
  if (tooglePerdaPacote.value == payload) return;
  tooglePerdaPacote.value = payload;
}
function handleLatenciaChange(payload: string) {
  if (toogleLatencia.value == payload) return;
  toogleLatencia.value = payload;
}
function handleGerALChangeAnalitico(payload: string) {
  if (toogleGeralAnalitico.value == payload) return;
  toogleGeralAnalitico.value = payload;
  investigandoDadoSelecionadoAnalitico.value = {};
}
function handleJiterChangeAnalitico(payload: string) {
  if (toogleJitterAnalitico.value == payload) return;
  toogleJitterAnalitico.value = payload;
}
function handlePerdaPacoteChangeAnalitico(payload: string) {
  if (tooglePerdaPacoteAnalitico.value == payload) return;
  tooglePerdaPacoteAnalitico.value = payload;
}

function handleLatenciaChangeAnalitico(payload: string) {
  if (toogleLatenciaAnalitico.value == payload) return;
  toogleLatenciaAnalitico.value = payload;
}

function handleCpuChangeAnalitico(payload: string) {
  if (toogleCpu.value == payload) return;
  toogleCpu.value = payload;
}

function handleConsumoInternet(payload: string) {
  if (toogleConsumoInternet.value == payload) return;
  toogleConsumoInternet.value = payload;
}

function getSaltos() {
  if (investigandoDadoSelecionado.value.connService_id)
    dadosCaminhoConectividade(investigandoDadoSelecionado.value.connService_id).then((f) => {
      steps.value = f.map((data: { avgLatency: any; avgJitter: any; packetLoss: any }, index: number) => {
        return {
          label: `Salto ${index + 1}`,
          completed: true,

          latencia: `${data.avgLatency} ms`,
          jitter: `${data.avgJitter} ms`,
          perda: data.packetLoss,
        } as IStep;
      });
    });
}

function getSaltosAnalitico() {
  if (investigandoDadoSelecionadoAnalitico.value.connService_id)
    dadosCaminhoConectividade(investigandoDadoSelecionadoAnalitico.value.connService_id).then((f) => {
      stepsAnalitco.value = f.map((data: { avgLatency: any; avgJitter: any; packetLoss: any }, index: number) => {
        return {
          label: `Salto ${index + 1}`,
          completed: true,

          latencia: `${data.avgLatency} ms`,
          jitter: `${data.avgJitter} ms`,
          perda: data.packetLoss,
        } as IStep;
      });
    });
}

async function GetLoadJitter(registrys: any[]) {
  if (isPredict.value) {
    jitterChatLine.value[0].data = (dadosPredictAlvo.value ?? [])
      .filter((f: { client: any }) => f.client == investigandoDadoSelecionado.value.client_unit_id)
      .map((f: { time: any; JiTTER: any }) => {
        return { title: f.time, value: f.JiTTER } as IDataChart;
      });
  } else {
    if (toogleJitter.value == 'minutos') {
      jitterChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.jitter } as IDataChart;
      });
    } else if (toogleJitter.value == '3minutos') {
      jitterChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.jitter } as IDataChart;
      });
    } else if (toogleJitter.value == 'horas') {
      jitterChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:00`, value: f.jitter } as IDataChart;
      });
    } else if (toogleJitter.value == 'dias') {
      jitterChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.day_time}/${f.month_time}`, value: f.jitter } as IDataChart;
      });
    }
  }
}

async function GetLoadLatencia(registrys: any[]) {
  if (isPredict.value) {
    latenciaChatLine.value[0].data = (dadosPredictAlvo.value ?? [])
      .filter((f: { client: any }) => f.client == investigandoDadoSelecionado.value.client_unit_id)
      .map((f: { time: any; LATENCY: any }) => {
        return { title: f.time, value: f.LATENCY } as IDataChart;
      });
  } else {
    if (toogleLatencia.value == 'minutos') {
      latenciaChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.latency } as IDataChart;
      });
    } else if (toogleLatencia.value == '3minutos') {
      latenciaChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.latency } as IDataChart;
      });
    } else if (toogleLatencia.value == 'horas') {
      latenciaChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:00`, value: f.latency } as IDataChart;
      });
    } else if (toogleLatencia.value == 'dias') {
      latenciaChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.day_time}/${f.month_time}`, value: f.latency } as IDataChart;
      });
    }
  }
}
async function GetLoadPerdaPacote(registrys: any[]) {
  if (isPredict.value) {
    perdaPacoteChatLine.value[0].data = (dadosPredictAlvo.value ?? [])
      .filter((f: { client: any }) => f.client == investigandoDadoSelecionado.value.client_unit_id)
      .map((f: { time: any; PACKET_LOSS: any }) => {
        return { title: f.time, value: f.PACKET_LOSS } as IDataChart;
      });
  } else {
    if (tooglePerdaPacote.value == 'minutos') {
      perdaPacoteChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.packet_loss } as IDataChart;
      });
    } else if (tooglePerdaPacote.value == '3minutos') {
      perdaPacoteChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.packet_loss } as IDataChart;
      });
    } else if (tooglePerdaPacote.value == 'horas') {
      perdaPacoteChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:00`, value: f.packet_loss } as IDataChart;
      });
    } else if (tooglePerdaPacote.value == 'dias') {
      perdaPacoteChatLine.value[0].data = registrys.map((f) => {
        return { title: `${f.day_time}/${f.month_time}`, value: f.packet_loss } as IDataChart;
      });
    }
  }
}

async function GetLoadJitterAnalitico(registrys: any[]) {
  if (isPredict.value) {
    jitterChatLineAnalitico.value[0].data = (registrys ?? [])
      .filter((f) => f.clientid == investigandoDadoSelecionadoAnalitico.value.clientid &&
        f.serviceid == investigandoDadoSelecionadoAnalitico.value.serviceid &&
        f.connservice == investigandoDadoSelecionadoAnalitico.value.connservice)
      .map((f) => {
        return { title: f.insert_time, value: f.jitter } as IDataChart;
      });
  } else {
    if (toogleJitter.value == 'minutos') {
      jitterChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.jitter } as IDataChart;
      });
    } else if (toogleJitter.value == '3minutos') {
      jitterChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.jitter } as IDataChart;
      });
    } else if (toogleJitter.value == 'horas') {
      jitterChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:00`, value: f.jitter } as IDataChart;
      });
    } else if (toogleJitter.value == 'dias') {
      jitterChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.day_time}/${f.month_time}`, value: f.jitter } as IDataChart;
      });
    }
  }
}

async function GetLoadLatenciaAnalitico(registrys: any[]) {
  if (isPredict.value) {
    latenciaChatLineAnalitico.value[0].data = (registrys ?? [])
      .filter((f) => f.clientid == investigandoDadoSelecionadoAnalitico.value.clientid &&
        f.serviceid == investigandoDadoSelecionadoAnalitico.value.serviceid &&
        f.connservice == investigandoDadoSelecionadoAnalitico.value.connservice)
      .map((f) => {
        return { title: f.insert_time, value: f.latency } as IDataChart;
      });
  } else {
    if (toogleLatencia.value == 'minutos') {
      latenciaChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.latency } as IDataChart;
      });
    } else if (toogleLatencia.value == '3minutos') {
      latenciaChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.latency } as IDataChart;
      });
    } else if (toogleLatencia.value == 'horas') {
      latenciaChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:00`, value: f.latency } as IDataChart;
      });
    } else if (toogleLatencia.value == 'dias') {
      latenciaChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.day_time}/${f.month_time}`, value: f.latency } as IDataChart;
      });
    }
  }
}
async function GetLoadPerdaPacoteAnalitico(registrys: any[]) {
  if (isPredict.value) {
    perdaPacoteChatLineAnalitico.value[0].data = (registrys ?? [])
      .filter((f) => f.clientid == investigandoDadoSelecionadoAnalitico.value.clientid &&
        f.serviceid == investigandoDadoSelecionadoAnalitico.value.serviceid &&
        f.connservice == investigandoDadoSelecionadoAnalitico.value.connservice)
      .map((f) => {
        return { title: f.insert_time, value: f.packet_loss } as IDataChart;
      });
  } else {
    if (tooglePerdaPacote.value == 'minutos') {
      perdaPacoteChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.packet_loss } as IDataChart;
      });
    } else if (tooglePerdaPacote.value == '3minutos') {
      perdaPacoteChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:${f.minute_time}`, value: f.packet_loss } as IDataChart;
      });
    } else if (tooglePerdaPacote.value == 'horas') {
      perdaPacoteChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.hour_time}:00`, value: f.packet_loss } as IDataChart;
      });
    } else if (tooglePerdaPacote.value == 'dias') {
      perdaPacoteChatLineAnalitico.value[0].data = registrys.map((f) => {
        return { title: `${f.day_time}/${f.month_time}`, value: f.packet_loss } as IDataChart;
      });
    }
  }
}

async function getStatusConectividade() {
  const id = Authentication.state.id ?? 187;
  const dados = await getPredict(route.params.item == 'porLink' ? 'LNK' : 'INT', id);

  const upData: any[] = dados.data;
  // dados.data?.map((x) => {
  //   x.map((y) => {
  //     upData.push(y);
  //   });
  // });
  rodouPrimary.value = true;
  await getPredictInvestigate('30', upData);
}
async function getInvestigateAll(minute: string) {
  analitsData.value = [];
  InvestigateAll(route.params.item == 'porLink' ? "LNK" : "SRV", minute).then(f => {
    Preloader.actions.ActionSetPreloader(true);
    const apx: any[] = [];
    f.data.map(ff => {
      ff.map(x => {

        apx.push({
          client_unity_name: x.CLIENT_UNITY_NAME,
          service_name: x.NAME,
          usuario: x.USUARIO,
          hostName: x.HOSTNAME,
          insert_time: x.TIME,
          coletor: x.COLETOR,
          availability: x.AVAILABILITY,
          quality: x.QUALITY,
          jitter: x.JiTTER,
          latency: x.LATENCY,
          packetloss: x.PACKET_LOSS,
          clientid: x.CLIENT_UNIT_ID,
          connservice: x.CONN_SERVICE_ID,
          serviceid: x.SERVICE_ID,
          type: x.TYPE,
        });

      });
    });
    analitsData.value = apx;
  }).finally(() => Preloader.actions.ActionSetPreloader(false));
}
async function getPredictInvestigate(minute: string, listApx?: any[]) {
  const id = Authentication.state.id ?? 187;
  const data = await getInvestigate(route.params.item == 'porLink' ? 'LNK' : 'INT', id, minute);
  if (data.data == null) return;
  diagnostico.value.loading = false;
  if (listApx && listApx.length) {
    if (route.params.dado == 'Saudáveis') {
      diagnostico.value.data = {
        listaDados: data.data.current
          .filter((f: { NAME: any }) => listApx.find((x) => x.status === 'saudavel' && x.name == f.NAME))
          .map((x: { CLIENT_UNITY_NAME: any; NAME: any; CLIENT_UNIT_ID: any }, _) => {
            return {
              id: _ + 1,
              client_unity_name: x.CLIENT_UNITY_NAME,
              service_name: x.NAME,
              availability: listApx.find((f) => f.status === 'saudavel' && f.name == x.NAME).availability,
              quality: listApx.find((f) => f.status === 'saudavel' && f.name == x.NAME).quality,
              client_unit_id: x.CLIENT_UNIT_ID,
            };
          }),
      };
    } else if (route.params.dado == 'Instáveis') {
      diagnostico.value.data = {
        listaDados: data.data.current
          .filter((f: { NAME: any }) => listApx.find((x) => x.status === 'instavel' && x.name == f.NAME))
          .map((x: { CLIENT_UNITY_NAME: any; NAME: any; CLIENT_UNIT_ID: any }, _) => {
            return {
              id: _ + 1,
              client_unity_name: x.CLIENT_UNITY_NAME,
              service_name: x.NAME,
              availability: listApx.find((f) => f.status === 'instavel' && f.name == x.NAME).availability,
              quality: listApx.find((f) => f.status === 'instavel' && f.name == x.NAME).quality,
              client_unit_id: x.CLIENT_UNIT_ID,
            };
          }),
      };
    } else if (route.params.dado == 'Degradados') {
      diagnostico.value.data = {
        listaDados: data.data.current
          .filter((f: { NAME: any }) => listApx.find((x) => x.status === 'degradado' && x.name == f.NAME))
          .map((x: { CLIENT_UNITY_NAME: any; NAME: any; CLIENT_UNIT_ID: any }, _) => {
            return {
              id: _ + 1,
              client_unity_name: x.CLIENT_UNITY_NAME,
              service_name: x.NAME,
              availability: listApx.find((f) => f.status === 'degradado' && f.name == x.NAME).availability,
              quality: listApx.find((f) => f.status === 'degradado' && f.name == x.NAME).quality,
              client_unit_id: x.CLIENT_UNIT_ID,
            };
          }),
      };
    } else if (route.params.dado == 'Problemáticos') {
      diagnostico.value.data = {
        listaDados: data.data.current
          .filter((f: { NAME: any }) => listApx.find((x) => x.status === 'problematico' && x.name == f.NAME))
          .map((x: { CLIENT_UNITY_NAME: any; NAME: any; CLIENT_UNIT_ID: any }, _) => {
            return {
              id: _ + 1,
              client_unity_name: x.CLIENT_UNITY_NAME,
              service_name: x.NAME,
              availability: listApx.find((f) => f.status === 'problematico' && f.name == x.NAME).availability,
              quality: listApx.find((f) => f.status === 'problematico' && f.name == x.NAME).quality,
              client_unit_id: x.CLIENT_UNIT_ID,
            };
          }),
      };
    }
  }
  dadosPredict.value = data.data.predict;
}
async function getLinksPorStatusConectividade() {
  const id = Authentication.state.id ?? 187;
  totalizadores.value = await linksPorStatusConectividade(6, id, FiltersUnit.getters.filters.value);
}

async function getServicosPorStatusConectividade() {
  const id = Authentication.state.id ?? 187;
  totalizadores.value = await servicosPorStatusConectividade(6, id, FiltersUnit.getters.filters.value);
}

async function getLinksServicosPorStatusConectividade() {
  const id = Authentication.state.id ?? 187;
  const data = await linksServicosPorStatusConectividade(id, route.params.item == 'porLink' ? 'LNK' : 'SRV');
  if (route.params.dado == 'Saudáveis') {
    analitsData.value = data.find((f: { status: string }) => f.status == 'saudavel').listaDados;
  } else if (route.params.dado == 'Instáveis') {
    analitsData.value = data.find((f: { status: string }) => f.status == 'instavel').listaDados;
  } else if (route.params.dado == 'Degradados') {
    analitsData.value = data.find((f: { status: string }) => f.status == 'degradado').listaDados;
  } else if (route.params.dado == 'Problemáticos') {
    analitsData.value = data.find((f: { status: string }) => f.status == 'problematico').listaDados;
  }
}



onMounted(async () => {
  if (!isPredict.value) {
    diagnostico.value = itemsDiagnostics.value.find((f) => f.item == route.params.dado);
    diagnostico.value.loading = true;
    if (route.params.item == 'porLink') {
      await getLinksPorStatusConectividade();
    } else {
      await getServicosPorStatusConectividade();
    }

    getLinksServicosPorStatusConectividade();
    if (route.params.dado == 'Saudáveis') {
      investigarItem.value = totalizadores.value.find((f) => f.status == 'saudavel');
    } else if (route.params.dado == 'Instáveis') {
      investigarItem.value = totalizadores.value.find((f) => f.status == 'instavel');
    } else if (route.params.dado == 'Degradados') {
      investigarItem.value = totalizadores.value.find((f) => f.status == 'degradado');
    } else if (route.params.dado == 'Problemáticos') {
      investigarItem.value = totalizadores.value.find((f) => f.status == 'problematico');
    }

    diagnostico.value.data = investigarItem.value;

    diagnostico.value.data.listaDados.map((item, _) => { item.id = _ + 1; });
    diagnostico.value.loading = false;
  } else {
    diagnostico.value = itemsDiagnostics.value.find((f) => f.item == route.params.dado);
    diagnostico.value.loading = true;
    await getStatusConectividade();
    analitsData.value = [];
    InvestigateAll(route.params.item == 'porLink' ? "LNK" : "SRV", '300').then(f => {
      Preloader.actions.ActionSetPreloader(true);
      const apx: any[] = [];
      f.data.map(ff => {
        ff.map(x => {

          apx.push({
            client_unity_name: x.CLIENT_UNITY_NAME,
            service_name: x.NAME,
            usuario: x.USUARIO,
            hostName: x.HOSTNAME,
            insert_time: x.TIME,
            coletor: x.COLETOR,
            availability: x.AVAILABILITY,
            quality: x.QUALITY,
            jitter: x.JiTTER,
            latency: x.LATENCY,
            packetloss: x.PACKET_LOSS,
            clientid: x.CLIENT_UNIT_ID,
            connservice: x.CONN_SERVICE_ID,
            serviceid: x.SERVICE_ID,
            type: x.TYPE,
          });

        });
      });
      apx.map((item, _) => { item.id = _ + 1; });
      analitsData.value = apx;
    }).finally(() => Preloader.actions.ActionSetPreloader(false));
  }
});

const __returned__ = { perPage, page, tabs, tab, selectedRow, route, router, isPredict, diagnostico, analitsData, labelComplementar, labelComplementarAnalitico, itemsDiagnostics, totalizadores, investigarItem, analistsDataComputed, steps, stepsAnalitco, activeColor, currentStep, currentStepAnalitico, dataChar, dataCharAnalitico, optionsListLatencia, optionsListPerda, optionsGeral, options, optionsListJitter, headersDetails, headersAnalitisc, dadosPredict, dadosPredictAlvo, jitterChatLine, latenciaChatLine, perdaPacoteChatLine, jitterChatLineAnalitico, latenciaChatLineAnalitico, perdaPacoteChatLineAnalitico, cpuAnalitico, consumoInternetArray, pontosPorHoraArray, investigandoDadoSelecionado, investigandoDadoSelecionadoAnalitico, handleReturnDash, handleRowClick, handleRowClickAnalitico, pontosPorHora, cpuGet, internetGet, graficoPontosHora, tooglePerdaPacote, toogleJitter, toogleLatencia, tooglePerdaPacoteAnalitico, toogleGeralAnalitico, toogleJitterAnalitico, toogleLatenciaAnalitico, toogleCpu, toogleConsumoInternet, toogleScore, rodouPrimary, handleJiterChange, handlePerdaPacoteChange, handleLatenciaChange, handleGerALChangeAnalitico, handleJiterChangeAnalitico, handlePerdaPacoteChangeAnalitico, handleLatenciaChangeAnalitico, handleCpuChangeAnalitico, handleConsumoInternet, getSaltos, getSaltosAnalitico, GetLoadJitter, GetLoadLatencia, GetLoadPerdaPacote, GetLoadJitterAnalitico, GetLoadLatenciaAnalitico, GetLoadPerdaPacoteAnalitico, getStatusConectividade, getInvestigateAll, getPredictInvestigate, getLinksPorStatusConectividade, getServicosPorStatusConectividade, getLinksServicosPorStatusConectividade, get OrganismsChart() { return OrganismsChart }, get OrganismsChartSaltos() { return OrganismsChartSaltos }, get AtomProgressSaltos() { return AtomProgressSaltos }, get AtomToogleButton() { return AtomToogleButton }, get ArrowLeftMobileIcon() { return ArrowLeftMobileIcon }, get AtomSubTitle() { return AtomSubTitle }, get AtomButton() { return AtomButton }, get MoleculeTable() { return MoleculeTable }, get MoleculeTabs() { return MoleculeTabs }, get MoleculeTabWindow() { return MoleculeTabWindow }, get MoleculeTabItem() { return MoleculeTabItem }, get getters() { return getters }, get state() { return state } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})